import { SearchModuleMaster } from "../../../../Utils/AllPagesQuriesAndMutations";
const PrintLayout_Conig = [
  {
    id: Math.random() * 10,
    name: "Page_Master",
    fields: [
      {
        id: Math.random() * 10,
        name: "tableKey",
        label: "Table Key",
        type: "InputDropForQuery",
        isRequired: true,
        // autoFocus: true,
        masterName: "Table_Master",
      },
      {
        id: Math.random() * 10,
        name: "licenseeId",
        label: "Licensee Id",
        type: "InputDropForQuery",
        masterName: "Licensee_Search_value",
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "layoutName",
        label: "LayoutName",
        type: "text",
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Company_Code",
        label: "Company Code ",
        masterName: "Company_With_licenseeNo",
        type: "InputDropForQuery",
        isRequired: true,
        Reference_field: ["licenseeId","", ["Unique_Id",] ],
      },
      {
        id: Math.random() * 10,
        name: "description",
        label: "Description",
        masterName: "SubMenu",
        type: "text",
        // Reference_field: "Menu_Master_Id",
        // // dropdowndata: getAllSubMenuSearch_WithMenuID,
        // type: "InputDropForQuery",
        // searchfield: "Menu_Id",
        // isRequired: true,
        //GetBranches_WithCompany_code
      },
      {
        id: Math.random() * 10,
        name: "Branch_Code",
        label: "Branch Code",
        masterName: "GetBranches_WithCompany_code",
        type: "InputDropForQuery",
        isRequired: true,
        Reference_field: ["Company_Code","", ["_id","licenseeNo"]],
      },
    ],
  },
];
export { PrintLayout_Conig };
